import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import './Sidebar.css';
import NavLabel from '../NavLabel';
import NavDrop from '../NavDrop';
import NavItem from '../NavItem';
import Checkbox from '../Checkbox';
import Logo from '../Logo';
import navValues from '../../helpers/NavigationValues';
import vendorActions from '../../actions/vendor';
import locationActions from '../../actions/location';
import refreshHelpers from '../../helpers/Refresh';


class Sidebar extends Component {
  constructor() {
    super();
    this.handleVendorClick = this.handleVendorClick.bind(this);
    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleCheckAllClick = this.handleCheckAllClick.bind(this);
    this.handleSearch = this.handleSearch.bind(this);

    this.state = {
      companyDropActive: false,
      locationDropActive: false
    }
  }

  componentWillMount() {
    this.setState({
      companySearch: '',
      locationSearch: ''
    })
  }

  handleSearch(e, field) {
    this.setState({
      [field]: e.target.value
    })
  }

  handleVendorClick(ven) {
    this.props.dispatch(vendorActions.selectCompany(ven));
    this.props.dispatch(locationActions.clearSelectedLocation(this.props.path));
    this.setState({
      companyDropActive: false
    });
  }

  handleCheckboxClick(id, value) {
    const { dispatch, location, vendor, path } = this.props;
    if (value == true) {
      dispatch(locationActions.selectLocation(location.data[id]))
      refreshHelpers.refetchPath(
        dispatch, path, vendor.selected.apikey, location.data[id].apikey);
    } else {
      dispatch(locationActions.clearSelectedLocation(path));
    }
    dispatch(locationActions.multiSelectLocation(id, value))
    this.setState({ locationDropActive: false });
  }

  handleCheckAllClick(id, value) {
    this.props.dispatch(locationActions.selectAllLocation(value))
  }

  render() {
    const { locationSearch, companySearch } = this.state;
    const { admin, vendor, location } = this.props;
    let campaignCount = 0;
    let customerCount = 0;
    if (admin.data && admin.data.campaigns) campaignCount = admin.data.campaigns;
    if (admin.data && admin.data.customers) customerCount = admin.data.customers;
    let activeVendor = '';
    let activeLocation = '';
    if (vendor.selected && vendor.selected.name) activeVendor = vendor.selected.name;
    if (location.selected && location.selected.name) activeLocation = location.selected.name;
    return (
      <div className="sidebar">
				<Logo/>
        {
          vendor.selected && vendor.selected.logo_url &&
          <img
            alt="Add a logo image"
            className="sidebar__logo"
            src={vendor.selected.logo_url} />
        }
				<div className="sidebar__stats sidebar__stats-left">
					<h3 className="sidebar__stats-number">
            {customerCount}
					</h3>
					<p className="sidebar__stats-label">
						Customers
					</p>
				</div>
				<div className="sidebar__stats">
					<h3 className="sidebar__stats-number">
            {campaignCount}
					</h3>
					<p className="sidebar__stats-label">
						Campaigns
					</p>
				</div>
				<div className="sidebar__dropdown">
          <NavDrop
            handleSearchChange={(e) => {this.handleSearch(e, 'companySearch')}}
            searchValue={companySearch}
            selectedText=""
            activeName={activeVendor}
            dropActive={this.state.companyDropActive}
            name="Company">
            <div className="sidebar__dropdown-items">
              {
                this.props.vendor.data.map((ven) => {
                  if (!ven.name.toLowerCase().includes(companySearch.toLowerCase())) return null;
                  
                  return (
                    <p
                      key={ven.apikey}
                      className="sidebar__dropdown-item"
                      onClick={() => {this.handleVendorClick(ven)}}>
                      {ven.name}
                    </p>
                  )
                })
              }
            </div>
          </NavDrop>
        </div>
				<div className="sidebar__dropdown">
          <NavDrop
            selectedText=""
            searchValue={locationSearch}
            activeName={activeLocation}
            dropActive={this.state.locationDropActive}
            handleSearchChange={(e) => {this.handleSearch(e, 'locationSearch')}}
            name="Location">
            <div className="sidebar__select-all">
    					<Checkbox
                sidebarIndex={1}
    						field={this.props.location.selectAll}
    						handleClick={this.handleCheckAllClick}/>
            </div>
            <div className="">
              <div className="sidebar__dropdown-items">
                {
                  this.props.location.checkbox.map((loc, index) => {
                    if (loc.name.toLowerCase().includes(locationSearch.toLowerCase())) {
                      return (
        								<Checkbox
                          key={index}
                          sidebarIndex={index}
        									field={loc}
        									handleClick={this.handleCheckboxClick}/>
                      )
                    }
                  })
                }
              </div>
            </div>
          </NavDrop>
  				{
  					navValues.map((labl, index) => {
  						return (
  							<div key={index}>
  								<NavLabel
  									key={index}
  									selectedText={labl.selectedText}
  									name={labl.label}>
  									{
  										labl.items.map((item, index) => {
  											return (
  												<NavItem
  													key={`nav-${index}`}
  													name={item.name}
  													showArrow={item.showArrow}
  													currentRoute={this.props.path}
  													toRoute={item.toRoute} />
  											)
  										})
  									}
                  </NavLabel>
  							</div>
  						)
  					})
  				}
				</div>
      </div>
    );
  }
}

Sidebar.propTypes = {
	path: PropTypes.string.isRequired
};

export default connect(
  (state) => ({
    vendor: state.vendor,
    location: state.location,
    admin: state.admin
  })
)(Sidebar);



/** WEBPACK FOOTER **
 ** ./src/components/Sidebar/index.js
 **/